export const englishMessages = {
  shell: {
    skipToContent: "Skip to content",
    brand: "PakPlan",
    navigation: "Foundation navigation",
    foundation: "Design foundation",
    serviceStatus: "Service status",
  },
  landing: {
    brandName: "PakPlan",
    homeLabel: "PakPlan home",
    skipToContent: "Skip to content",
    navigationLabel: "Public navigation",
    navigation: {
      howItWorks: "How it works",
      pricing: "Pricing",
    },
    actions: {
      signUp: "Start free",
      signIn: "Sign in",
      goToPlans: "Go to plans",
      exploreFeatures: "Explore features",
      agentGuide: "Use your favourite agent, like ChatGPT",
    },
    hero: {
      eyebrow: "Packing lists to fleet plans",
      titleFirst: "Quote faster.",
      titleSecond: "Plan every load.",
      summary:
        "Turn packing lists into truck counts, rental costs and 3D load plans. Spend less time preparing each estimate.",
      trial: "1-month free trial",
      noCreditCard: "No credit card required",
      helper: "1-month free trial · No credit card required",
      animationDescription:
        "Three empty sample trucks fill with cargo in PakPlan’s fleet view, hold the packed layout, then repeat.",
      imageCaption: "Sample fleet in 3D.",
    },
    features: {
      eyebrow: "Less admin. Faster estimates.",
      title: "From customer list to costed fleet.",
      imports: {
        title: "Skip the reformatting",
        description:
          "Import Excel or CSV, or paste a packing list. PakPlan recognises columns and units across different layouts.",
      },
      fleet: {
        title: "See how it fits",
        description:
          "Inspect every truck in 3D, check axle loads and share a loading plan your team can use.",
      },
      cost: {
        title: "Cost the job faster",
        description:
          "Compare truck counts and rental costs using your saved rates per complete trip. Choose fewer trucks or lower cost.",
      },
    },
    explanation: {
      title: "Import. Compare. Share.",
      steps: {
        bring: {
          number: "1",
          title: "Bring your packing list",
          description:
            "Upload your customer’s list, or let your favourite AI agent prepare it for you.",
        },
        explore: {
          number: "2",
          title: "Choose your fleet plan",
          description: "Compare rental totals and truck counts. Open any load in 3D.",
        },
        share: {
          number: "3",
          title: "Share the plan",
          description:
            "Send a link or download loading instructions. Your team can open the plan without an account.",
        },
      },
    },
    pricing: {
      title: "Simple pricing for your team.",
      description: "Start with one. Grow your team. Never more than $250 a month.",
      teamSize: "Team size",
      user: "user",
      users: "users",
      userCount_one: "{{count}} user",
      userCount_other: "{{count}} users",
      tenPlus: "10 or more users",
      planned: "Planned monthly pricing · USD",
      perMonth: "/ month total",
      perUser: "per user / month",
      capped: "10+ users · one team price",
      features: {
        imports: "Flexible packing-list imports",
        comparison: "Truck and rental-cost comparisons",
        fleet: "3D fleet and load plans",
        sharing: "Shareable loading instructions",
      },
      note: "Illustrative pricing. PakPlan is free to use today, with no automatic charges.",
    },
    closing: {
      title: "Spend less time on your next estimate.",
      description: "Bring your packing list. Get your fleet plan.",
      existingAccount: "Already have an account?",
    },
    footer: {
      domain: "PakPlan.com",
      backToTop: "Back to top",
      agentGuide: "Plan with an AI agent",
    },
  },
  foundation: {
    title: "PakPlan design foundation",
    description:
      "The shared color, spacing, typography, accessibility, and runtime boundaries are ready for product screens.",
    tokenRegion: "Design token samples",
    tokens: {
      brand: "Brand focus",
      success: "Success",
      warning: "Warning",
    },
  },
  status: {
    title: "API service status",
    description:
      "This diagnostic checks process liveness without treating dependency readiness as the same signal.",
    loading: "Checking API liveness…",
    up: "Process is up",
    unavailable: "Could not reach the API process.",
    retry: "Retry",
  },
  route: {
    loading: "Loading…",
    errorTitle: "Could not open this page",
    errorDescription: "Reload the page or return to your plans.",
    returnHome: "Return to plans",
  },
  dialog: {
    cancel: "Cancel",
  },
  toast: {
    dismiss: "Dismiss notification",
  },
} as const;
